import {
  Button,
  Card,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { BIBlue } from "../../assets/helpers";
import Addeducation from "./Addeducation";
import { FETCH_USER_TRADE_CERTIFICATION } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import { useSelector } from "react-redux";
import moment from "moment";
import { Edit as EditIcon } from "@mui/icons-material";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";
import { English } from "../../constant/EnglishFallback";
import Loader from "../../common/Loader";
import EducationSekeleton from "./EducationSkeleton";

export default function Education({ profileSectionLoadingState, setProfileSectionLoadingState }) {
  const [showEducation, setShoweducation] = useState(false);
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const [educationlist, setEducationlist] = useState([]);
  const [editEducation, setEditeducation] = useState(true);
  const [addEducationFlag, setAddEducationFlag] = useState(false);
  const [id, setId] = useState(0);
  const { userId } = useParams();
  const [isFormUserDashboard, setIsFormUserDashboard] = useState(false);
  const [education, setEducation] = useState({
    id: 0,
    school: "",
    study: "",
    startDate: dayjs(),
    endDate: dayjs(),
    present: false,
    from: "addEducation"
  });

  const {
    BUTTON_EDIT = English?.Profile?.BUTTON_EDIT,
    TEXT_MY_EDUCATION = English?.Profile?.TEXT_MY_EDUCATION,
    TEXT_EDUCATION_INFO = English?.Profile?.TEXT_EDUCATION_INFO,
    BUTTON_ADD_MY_EDUCATION = English?.Profile?.BUTTON_ADD_MY_EDUCATION,
    BUTTON_BACK = English?.Profile?.BUTTON_BACK,
    TEXT_EDUCATION_DESCRIPTION = English?.Profile?.TEXT_EDUCATION_DESCRIPTION
  } = multiLanguageData?.Profile || {};

  useEffect(() => {
    fetchEducation();
    if (loginData?.userInformation?.UserId !== Number(userId)) {
      setIsFormUserDashboard(true);
    } else {
      setIsFormUserDashboard(false);
    }
  }, [userId]);

  const fetchEducation = async () => {
    try {
      setProfileSectionLoadingState((prev) => ({
        ...prev,
        certificationLoader: true
      }));
      let getResponse = await Postrequestcall(
        FETCH_USER_TRADE_CERTIFICATION,
        { SearchList: [{ UserId: userId }] },
        loginData?.accessToken
      );
      if (getResponse?.status === 201) {
        let educationData = getResponse?.data?.data;
        const sortedData = [...educationData].sort((a, b) => {
          const dateA = a.endDate ? new Date(a.endDate) : new Date();
          const dateB = b.endDate ? new Date(b.endDate) : new Date();
          return dateB - dateA || new Date(b.startDate) - new Date(a.startDate);
        });
        setEducationlist(sortedData);
        setAddEducationFlag(getResponse?.data?.data?.length == 0 ? true : false);
        setProfileSectionLoadingState((prev) => ({
          ...prev,
          certificationLoader: false
        }));
      }
    } catch (error) {
      console.log("fetchEducation-> Error While Fetching User Trade Certification: ", error);
      setProfileSectionLoadingState((prev) => ({
        ...prev,
        certificationLoader: false
      }));
    }
  };

  const handleEducation = () => {
    setEditeducation(!editEducation);
  };

  const handleAddEducation = () => {
    setId(0);
    setShoweducation(true);
    setEducation({
      id: 0,
      school: "",
      study: "",
      startDate: dayjs(),
      endDate: dayjs(),
      present: false,
      from: "addEducation"
    });
  };

  const handleEditEducation = (item) => {
    setEducation({
      id: item?.id,
      school: item?.school,
      study: item?.fieldOfStudy,
      startDate: item?.startDate,
      endDate: item?.endDate,
      present: item?.isPresent,
      from: "editEducation"
    });
    setId(item?.id);
    setShoweducation(true);
  };

  if (profileSectionLoadingState?.certificationLoader) {
    return <EducationSekeleton />;
  }
  return (
    <>
      <Card
        className="pagelist-content"
        style={{
          maxHeight: profileSectionLoadingState?.certificationLoader ? "" : "45vh",
          overflow: "scroll",
          scrollbarWidth: "none"
        }}>
        <Stack
          direction="column"
          gap={"8px"}
          sx={{
            padding: "10px",
            position: "sticky",
            top: "0px",
            background: "white",
            width: "auto",
            zIndex: "1"
          }}>
          <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"} pb={1}>
            <Typography variant="h6">
              {editEducation ? TEXT_MY_EDUCATION : TEXT_EDUCATION_INFO}
            </Typography>
            {isFormUserDashboard ? null : (
              <>
                {addEducationFlag ? (
                  <Button
                    variant="contained"
                    sx={{ width: "fit-content", backgroundColor: BIBlue }}
                    className="active-btn"
                    onClick={() => handleAddEducation()}>
                    {BUTTON_ADD_MY_EDUCATION}
                  </Button>
                ) : (
                  <Stack flexDirection={"row"} gap={1}>
                    {/* <Button
                      variant="contained"
                      sx={{ width: "fit-content", backgroundColor: BIBlue }}
                      className="active-btn"
                      onClick={() => handleEducation()}>
                      {editEducation ? BUTTON_BACK : BUTTON_EDIT}
                    </Button> */}
                    {editEducation && (
                      <Button
                        variant="contained"
                        sx={{ width: "fit-content", backgroundColor: BIBlue }}
                        className="active-btn"
                        onClick={() => handleAddEducation()}>
                        {BUTTON_ADD_MY_EDUCATION}
                      </Button>
                    )}
                  </Stack>
                )}
              </>
            )}
          </Stack>
          {isFormUserDashboard ? null : (
            <>{addEducationFlag && <Typography>{TEXT_EDUCATION_DESCRIPTION}</Typography>}</>
          )}
        </Stack>
        <List disablePadding>
          <Stack spacing={1} margin={1}>
            {educationlist?.map((item) => (
              <Card key={item?.id} className="pagelist-content" style={{ padding: "10px" }}>
                <ListItem
                  sx={{ padding: 0 }}
                  disablePadding
                  secondaryAction={
                    <>
                      {editEducation && !isFormUserDashboard ? (
                        <IconButton
                          edge="end"
                          color="primary"
                          onClick={() => handleEditEducation(item)}>
                          <EditIcon />
                        </IconButton>
                      ) : null}
                    </>
                  }>
                  <ListItemText
                    sx={{ m: 0 }}
                    primary={item?.fieldOfStudy}
                    secondary={
                      <Stack>
                        <Stack>{item?.school}</Stack>
                        <Stack>
                          {" "}
                          {item?.startDate !== null && item?.startDate !== "" ? (
                            <span>
                              {moment(item?.startDate).format("MMM YYYY")} -{" "}
                              {item?.isPresent === false
                                ? item?.endDate == null || item?.endDate == "Invalid date"
                                  ? null
                                  : moment(item?.endDate).format("MMM YYYY")
                                : "Present"}{" "}
                              <br />{" "}
                            </span>
                          ) : null}
                        </Stack>
                      </Stack>
                    }
                  />
                </ListItem>
              </Card>
            ))}
          </Stack>
        </List>
      </Card>
      {showEducation && (
        <Addeducation
          id={id}
          fetchEducation={fetchEducation}
          onOpen={showEducation}
          onClose={() => setShoweducation(false)}
          educationData={education}
        />
      )}
    </>
  );
}
